import React from 'react';
import './Footer.css';

const Footer = () => {
    return (<footer className="main-footer">
        <div className="footer-top">
            <div className="footer-logo">
                <img src="/images/esae-logo-white-transparent.png" alt="Rare Diseases Greece Logo"/>
            </div>
            <div className="footer-contact">
                <p>Διεύθυνση: Καπνικαρέας 19Α, Τ.Κ. 105 56, Αθήνα</p>
                <p>
                    Email: <a href="mailto:info@rarediseasesgreece.gr">info@rarediseasesgreece.gr</a>
                </p>
                <div className="footer-links">
                    <a href="/documents/RGD%20Map-%20Terms%20of%20conditions.pdf" target="_blank"
                       rel="noopener noreferrer">Όροι Χρήσης</a>
                    <a href="/documents/RDG%20Map%20Privacy%20Policy_%20v1.0.pdf" target="_blank"
                       rel="noopener noreferrer">Πολιτική Απορρήτου</a>
                    <a href="/documents/Security%20policy%20RDG%20MAp%20v1.0.pdf" target="_blank"
                       rel="noopener noreferrer">Πολιτική Ασφαλείας</a>
                </div>
            </div>
        </div>
        <div className="footer-bottom">
            <p>© {new Date().getFullYear()} Rare Diseases Greece. All rights reserved.</p>
            <p className="footer-credit">
                Developed by <a href="https://aperia.io" target="_blank" rel="noopener noreferrer">Aperia</a>
            </p>
        </div>
    </footer>);
};

export default Footer;
